<template>
  <div v-if="count" class="Preloader">
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.97109 35.6127C4.22916 35.6127 3.48722 35.2417 3.04206 34.4998C2.44851 33.4611 2.81948 32.0514 3.85819 31.4579L7.34528 29.4547C8.38399 28.8611 9.79367 29.2321 10.3872 30.2708C10.9808 31.3095 10.6098 32.7192 9.57109 33.3127L6.08399 35.3159C5.78722 35.5385 5.41625 35.6127 4.97109 35.6127Z"
        fill="#11AEBA"
      />
      <path
        d="M12.6127 43.1806C12.2417 43.1806 11.8708 43.1064 11.4998 42.8838C10.4611 42.2903 10.0901 40.8806 10.6837 39.8419L12.6869 36.3548C13.2804 35.3161 14.6901 34.9451 15.7288 35.5386C16.7675 36.1322 17.1385 37.5419 16.5449 38.5806L14.5417 42.0677C14.0966 42.8096 13.3546 43.1806 12.6127 43.1806Z"
        fill="#0FB8BC"
      />
      <path
        d="M23.0002 46C21.7389 46 20.7744 45.0355 20.7744 43.7742V39.6936C20.7744 38.4323 21.7389 37.4678 23.0002 37.4678C24.2615 37.4678 25.226 38.4323 25.226 39.6936V43.7742C25.226 45.0355 24.2615 46 23.0002 46Z"
        fill="#0DBFBA"
      />
      <path
        d="M33.3874 43.1806C32.6455 43.1806 31.9035 42.8096 31.4584 42.0677L29.4551 38.5806C28.8616 37.5419 29.2326 36.1322 30.2713 35.5386C31.31 34.9451 32.7197 35.3161 33.3132 36.3548L35.3164 39.8419C35.91 40.8806 35.539 42.2903 34.5003 42.8838C34.1293 43.1064 33.7584 43.1806 33.3874 43.1806Z"
        fill="#1BCEB8"
      />
      <path
        d="M41.0294 35.6127C40.6585 35.6127 40.2875 35.5385 39.9165 35.3159L36.3553 33.3127C35.3165 32.7192 34.9456 31.3095 35.5391 30.2708C36.1327 29.2321 37.5424 28.8611 38.5811 29.4547L42.0681 31.4579C43.1069 32.0514 43.4778 33.4611 42.8843 34.4998C42.5133 35.2417 41.7714 35.6127 41.0294 35.6127Z"
        fill="#26DBC0"
      />
      <path
        d="M43.7742 25.226H39.6936C38.4323 25.226 37.4678 24.2615 37.4678 23.0002C37.4678 21.7389 38.4323 20.7744 39.6936 20.7744H43.7742C45.0355 20.7744 46 21.7389 46 23.0002C46 24.2615 45.0355 25.226 43.7742 25.226Z"
        fill="#2EE5C6"
      />
      <path
        d="M37.4682 16.8417C36.7262 16.8417 35.9843 16.4708 35.5391 15.7288C34.9456 14.6901 35.3165 13.2804 36.3553 12.6869L39.8423 10.6837C40.8811 10.0901 42.2907 10.4611 42.8843 11.4998C43.4778 12.5385 43.1069 13.9482 42.0681 14.5417L38.5811 16.5449C38.2101 16.7675 37.8391 16.8417 37.4682 16.8417Z"
        fill="#3BEDCB"
      />
      <path
        d="M31.3842 10.7582C31.0132 10.7582 30.6422 10.684 30.2713 10.4614C29.2326 9.86789 28.8616 8.45821 29.4551 7.4195L31.4584 3.93241C32.0519 2.8937 33.4616 2.52273 34.5003 3.11628C35.539 3.70983 35.91 5.1195 35.3164 6.15821L33.3132 9.64531C32.868 10.3131 32.1261 10.7582 31.3842 10.7582Z"
        fill="#57F7D8"
      />
      <path
        d="M23.0002 8.53226C21.7389 8.53226 20.7744 7.56774 20.7744 6.30645V2.22581C20.7744 0.964516 21.7389 0 23.0002 0C24.2615 0 25.226 0.964516 25.226 2.22581V6.30645C25.226 7.49355 24.2615 8.53226 23.0002 8.53226Z"
        fill="#76FFE5"
      />
      <path
        d="M14.6159 10.7582C13.874 10.7582 13.132 10.3872 12.6869 9.64531L10.6837 6.15821C10.0901 5.1195 10.4611 3.70983 11.4998 3.11628C12.5385 2.52273 13.9482 2.8937 14.5417 3.93241L16.5449 7.4195C17.1385 8.45821 16.7675 9.86789 15.7288 10.4614C15.432 10.6098 14.9869 10.7582 14.6159 10.7582Z"
        fill="#BBFFF2"
      />
      <path
        d="M8.53241 16.8417C8.16144 16.8417 7.79047 16.7675 7.4195 16.5449L3.93241 14.5417C2.8937 13.9482 2.52273 12.5385 3.11628 11.4998C3.70983 10.4611 5.1195 10.0901 6.15821 10.6837L9.64531 12.6869C10.684 13.2804 11.055 14.6901 10.4614 15.7288C10.0163 16.4708 9.27434 16.8417 8.53241 16.8417Z"
        fill="#E1FFF9"
      />
      <path
        d="M6.30645 25.226H2.22581C0.964516 25.226 0 24.2615 0 23.0002C0 21.7389 0.964516 20.7744 2.22581 20.7744H6.30645C7.56774 20.7744 8.53226 21.7389 8.53226 23.0002C8.53226 24.2615 7.49355 25.226 6.30645 25.226Z"
        fill="#F3FFFD"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'AppPreloader',
  data() {
    return {
      count: true,
    };
  },
  mounted() {
    const perfData = window.performance.timing;
    const EstimatedTime = -(perfData.loadEventEnd - perfData.navigationStart);
    const time = parseInt((EstimatedTime / 1000) % 60) * 100;

    const start = 0;
    const end = 100;
    const duration = time;
    animateValue(start, end, duration);

    function animateValue(start, end, duration) {
      const range = end - start;
      let current = start;
      const increment = end > start ? 1 : -1;
      const stepTime = Math.abs(Math.floor(duration / range));
      const timer = setInterval(function() {
        current += increment;
        // console.log(this)
        if (current >= end) {
          clearInterval(timer);
        }
      }, stepTime);
    }
    // console.log(time)
    setTimeout(() => {
      this.count = false;
    }, time);
  },
};
</script>
<style lang="sass">
.Preloader
  position: fixed
  z-index: 1000000
  left: 0
  right: 0
  bottom: 0
  top: 0
  background: #14131A
  display: flex
  justify-content: center
  align-items: center
  svg
    path
      &:nth-child(1)
        animation: preload 2.4s 2.4s infinite forwards
      &:nth-child(2)
        animation: preload 2.4s 2.2s infinite forwards
      &:nth-child(3)
        animation: preload 2.4s 2s infinite forwards
      &:nth-child(4)
        animation: preload 2.4s 1.8s infinite forwards
      &:nth-child(5)
        animation: preload 2.4s 1.6s infinite forwards
      &:nth-child(6)
        animation: preload 2.4s 1.4s infinite forwards
      &:nth-child(7)
        animation: preload 2.4s 1.2s infinite forwards
      &:nth-child(8)
        animation: preload 2.4s 1s infinite forwards
      &:nth-child(9)
        animation: preload 2.4s 0.8s infinite forwards
      &:nth-child(10)
        animation: preload 2.4s 0.6s infinite forwards
      &:nth-child(11)
        animation: preload 2.4s 0.4s infinite forwards
      &:nth-child(12)
        animation: preload 2.4s 0.2s infinite forwards
  @keyframes preload
    0%
      opacity: 0
    100%
      opacity: 1
</style>
